import { MenuItem, Select } from '@mui/material';

import { AnalyticsTriggerElementProps } from '@common/types';
import { ListFilterSelectWrapLine } from '@common/ui/ListFilters/common';

import { AqlBuilderOperator, AqlBuilderOperatorDisplayName } from '@Inventory/AqlBuilder/helpers/common';

interface AqlBuilderOperatorSelectProps {
  options: AqlBuilderOperator[];
  value?: AqlBuilderOperator;
  onChange: (value: AqlBuilderOperator) => void;
}

export default function AqlBuilderOperatorSelect({
  options,
  value,
  onChange,
  ...analyticsProps
}: AqlBuilderOperatorSelectProps & AnalyticsTriggerElementProps) {
  const optionsToSelect = options.map((o) => ({
    value: o,
    label: AqlBuilderOperatorDisplayName[o],
  }));

  return (
    <ListFilterSelectWrapLine>
      <Select
        value={value || options?.[0]}
        onChange={(e) => onChange(e.target.value as AqlBuilderOperator)}
        size="small"
        fullWidth
        data-testid="aql-builder-operator-select"
        {...analyticsProps}
      >
        {optionsToSelect.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </ListFilterSelectWrapLine>
  );
}
